import React, {useEffect, useState} from 'react'
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import NativeSelect from '@mui/material/NativeSelect';
import FormControl from '@mui/material/FormControl';

import { useAppSelector } from '../../../hooks';
import { selectBreakPoints } from '../../../Slices/appSlicer'
import { chartPhoneStyle} from '../style'

const RoomTab = () => {

  const [date, setDate] = React.useState('this-week');
  const [chartDimension , setChartDimension] = useState<{width: number, height: number}>({width: 800, height:400})
  const breakpoints = useAppSelector(selectBreakPoints)
  const handleChange = (event: SelectChangeEvent) => {
    setDate(event.target.value);
  };
  
  useEffect(() => {
    if(breakpoints.ipadPotrait){
      setChartDimension({width: 600, height: 300})
    } else if(breakpoints.iphonePotrait){
      setChartDimension({width: 350, height: 300})
    }
   
  },[breakpoints])
  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Grid container spacing={2}>
        <Grid pp={12} ip={12} md={12} sx={{ display: "flex", justifyContent: "end" }}>
          <FormControl >

            <NativeSelect
              defaultValue={"this-week"}
              inputProps={{
                name: 'age',
                id: 'uncontrolled-native',
              }}
            >
              <option value={"this-week"}>This Week</option>
              <option value={"previous-week"}>Previous Week</option>
              <option value={"last-month"}>Last Month</option>
            </NativeSelect>
          </FormControl>

        </Grid>
        <Grid sx={chartPhoneStyle} sm={12}>
          <LineChart
            width={chartDimension.width}
            height={chartDimension.height}
            data={data}
            margin={{
              top: 10,
              right: 30,
              left: 10,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="0 1" />
            <XAxis dataKey="name" />
            <YAxis dataKey={"day"} />
            <Tooltip />
            <Line type="monotone" dataKey="day" stroke="#E7F011" activeDot={{ r: 8 }} />
          </LineChart>
        </Grid>
      </Grid>

    </Container>
  )
}
const data = [
  {
    name: 'Mon',
    day: 5,
  },
  {
    name: 'Tue',
    day: 7,
  },
  {
    name: 'Wed',
    day: 8,
  },
  {
    name: 'Thu',
    day: 4,
  },
  {
    name: 'Fri',
    day: 3,
  },
  {
    name: 'Sat',
    day: 5,
  },
  {
    name: 'Sun',
    day: 4,
  },
];
export default RoomTab